import { Routes } from "@angular/router";

import { isExternalAppType, isInternalAppType } from "@azm/core/enums/app-types";
import { authGuard } from "@azm/core/guards/auth";
import { UserRoles } from "@azm/core/enums/user-roles";
import { roleResolver } from "@azm/core/resolvers/role";
import { SidebarService } from "@azm/core/services/sidebar";
import { sidebarResolver } from "@azm/core/resolvers/sidebar";
import { permissionsGuard } from "@azm/core/guards/permissions";
import { permissionsResolver } from "@azm/core/resolvers/permissions";

import { authRoutes } from "@azm/features/auth";
import { homeExternalRoutes } from "@azm/features/home-external";

import { isInternalShellRoute } from "@azm/core/utilities/internal-shell-route";
import { environment } from "@azm/environments/environment";

export const routes: Routes = [
	{
		path: "error",
		loadChildren: () => import("./features/error").then((c) => c.errorRoutes),
	},
	{
		path: "",
		children: [
			{
				path: "",
				data: { isLanding: true },
				canActivate: [authGuard],
				canMatch: [() => isExternalAppType(environment.defaultAppType)],
				children: homeExternalRoutes,
			},
			{ path: "", redirectTo: "auth", pathMatch: "full" },
			{
				path: "token-access-error",
				loadComponent: () =>
					import("@azm/features/auth/pages/token-access-error/token-access-error.component").then((m) => m.TokenAccessErrorPage),
			},
			{
				path: "signin-oidc",
				loadComponent: () =>
					import("@azm/features/auth/pages/lawyer-sso-signin-callback/lawyer-sso-signin-callback.component").then(
						(m) => m.LawyerSsoSigninCallback,
					),
			},
			{
				path: "signout-callback-oidc",
				loadComponent: () =>
					import("@azm/features/auth/pages/lawyer-sso-signout-callback/lawyer-sso-signout-callback.component").then(
						(m) => m.LawyerSsoSignoutCallback,
					),
			},
			{
				path: "sample",
				loadChildren: () => import("@azm/features/sample").then((r) => r.sampleRoutes),
			},
			{
				path: "decisions",
				data: { isLanding: true },
				loadChildren: () => import("./features/public-decision-details/decision-details.routes").then((c) => c.decisionDetailsRoutes),
			},
			{
				path: "decision-verification",
				data: { isLanding: true },
				canMatch: [() => isExternalAppType(environment.defaultAppType)],
				loadChildren: () =>
					import("./features/decision-verification/decision-verification.routes").then((c) => c.decisionVerificationRoutes),
			},
			{
				path: "auth",
				data: { isLanding: true },
				canActivate: [authGuard],
				children: authRoutes,
			},
			{
				path: "",
				providers: [SidebarService],
				resolve: { activeRoute: roleResolver, sidebar: sidebarResolver, permissions: permissionsResolver },
				data: { isLanding: false },
				canActivate: [authGuard],
				canActivateChild: [permissionsGuard],
				loadComponent: () => import("./core/components/layout").then((c) => c.Layout),
				children: [
					{
						path: "individual",
						data: { role: UserRoles.Individual },
						canMatch: [() => isExternalAppType(environment.defaultAppType)],
						loadChildren: () => import("./features/layouts/routes/").then((c) => c.individualRoutes),
					},
					{
						path: "individual",
						data: { role: UserRoles.Internal },
						canMatch: [() => isInternalAppType(environment.defaultAppType)],
						loadChildren: () => import("./features/layouts/routes/").then((c) => c.internalRoutes),
					},
					{
						path: "business",
						data: { role: UserRoles.Business },
						canMatch: [() => isExternalAppType(environment.defaultAppType)],
						loadChildren: () => import("./features/layouts/routes/").then((c) => c.businessRoutes),
					},
					{
						path: "government",
						data: { role: UserRoles.Government },
						canMatch: [() => isExternalAppType(environment.defaultAppType)],
						loadChildren: () => import("./features/layouts/routes/").then((c) => c.governmentRoutes),
					},
					{
						path: "",
						data: { role: UserRoles.Internal },
						canMatch: [() => isInternalShellRoute()],
						loadChildren: () => import("./features/layouts/routes/").then((c) => c.internalRoutes),
					},
				],
			},
		],
	},
	{ path: "**", redirectTo: "error/404" },
];
